import { render, staticRenderFns } from "./FollowUpSuggestions.vue?vue&type=template&id=a87cfef8&scoped=true&"
import script from "./FollowUpSuggestions.vue?vue&type=script&lang=js&"
export * from "./FollowUpSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpSuggestions.vue?vue&type=style&index=0&id=a87cfef8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cfef8",
  null
  
)

export default component.exports